<template>
    <div class="kpi">
        <v-card class="rounded-xl " flat>
            <v-card-title class="text-h6 font-weight-bold">
                Dữ liệu KPI
            <v-spacer></v-spacer> 
            
            <div class="d-flex align-center wrapper mx-1 my-1">
                <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
            </div>
            <v-divider vertical class="mx-4"></v-divider>

            <vue-excel-xlsx
                :data="excelData"
                :columns="excelColumns"
                :file-name="'DU_LIEU_KPI'"
                :file-type="'xlsx'"
                :sheet-name="'DuLieuKPI'"
                class="d-flex"
                >
                <v-btn outlined color="teal darken-4" class="d-flex rounded-xl" style="text-transform: none;">
                    <v-icon left small>mdi-file-excel</v-icon> Xuất excel
                </v-btn>
            </vue-excel-xlsx>
            </v-card-title>
            
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <div class="d-flex align-center wrapper mx-2 my-2">
                        <month-picker width="7rem" v-model="filters.month" label="Tháng" outlined dense></month-picker>
                    </div>

                    <!-- start filtering -->
                    <v-text-field label="Mã Store" dense v-model="storeNo" outlined hide-details persistent-placeholder
                    class="mx-2 my-2 flex-shrink-1" style="max-width: 250px; background-color: white;"></v-text-field>
                </div>
            </v-sheet>
            
            <v-data-table
                item-key="id"
                :mobile-breakpoint="0"
                height="600px" fixed-header
                :headers="dynamicHeaders"
                :items="filteredItems"
                :loading="isLoading"
                loading-text="Đang tải dữ liệu..."
                :footer-props="{
                    itemsPerPageOptions:[
                    50, 100, 200
                    ]
                }"
            >
                <template v-slot:[`item.employeeName`]="{ item }">
                    <div class="font-weight-bold primary--text text--darken-2" style="font-size: 15px;">{{ item.employeeName }}</div>
                </template>
                <template v-slot:[`item.employeeCode`]="{ item }">
                    <v-chip small color="grey lighten-3" class="font-weight-medium grey--text text--darken-3">{{ item.employeeCode }}</v-chip>
                </template>
                <template v-slot:[`item.storeCode`]="{ item }">
                    <v-chip small color="teal lighten-5" text-color="teal darken-3" class="font-weight-bold">
                        <v-icon small left color="teal darken-3">mdi-store</v-icon> {{ item.storeCode }}
                    </v-chip>
                </template>
                <template v-slot:[`item.postingdate`]="{ item }">
                    <v-chip small outlined color="primary"><v-icon small left>mdi-calendar</v-icon>{{ formatMonthYear(item.postingdate) }}</v-chip>
                </template>
                <template v-slot:[`item.postingDate`]="{ item }">
                    <v-chip small outlined color="primary"><v-icon small left>mdi-calendar</v-icon>{{ formatMonthYear(item.postingDate) }}</v-chip>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import * as moment from "moment/moment";

export default {
    name: "KPI",
    components: {
    },
    watch: {
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        }
    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        dynamicHeaders() {
            if (this.items.length === 0) return [];
            const keys = Object.keys(this.items[0]);
            
            const nameMap = {
                'employeeCode': { text: 'Mã NV', width: '110px' },
                'employeeName': { text: 'Tên Nhân Viên', width: '220px' },
                'storeCode': { text: 'Mã Đơn Vị', width: '130px' },
                'storeName': { text: 'Tên Đơn Vị', width: '200px' },
                'departmentName': { text: 'Phòng Ban', width: '180px' },
                'postingdate': { text: 'Kỳ Đánh Giá', align: 'center', width: '140px' },
                'postingDate': { text: 'Kỳ Đánh Giá', align: 'center', width: '140px' },
                'kpiValue': { text: 'Điểm KPI', align: 'end', width: '120px' },
                'point': { text: 'Điểm', align: 'end', width: '100px' },
                'note': { text: 'Ghi Chú', width: '200px' },
                'id': { text: '', align: ' d-none' }
            };

            return keys.map(key => {
                let config = nameMap[key] || {
                    text: key.charAt(0).toUpperCase() + key.slice(1),
                    align: 'start',
                };
                
                return {
                    ...config,
                    value: key,
                };
            });
        },
        excelColumns() {
            return this.dynamicHeaders.filter(h => h.value !== 'id' && h.value !== 'actions').map(h => {
                return {
                    label: h.text,
                    field: h.value
                };
            });
        },
        filteredItems() {
            if (!this.storeNo) return this.items;
            const search = this.storeNo.toLowerCase();
            return this.items.filter(item => {
                const sCode = item.storeCode || item.storeNo || '';
                return sCode.toLowerCase().includes(search);
            });
        },
        excelData() {
            return this.filteredItems.map(item => {
                let mappedItem = { ...item };
                if (mappedItem.postingdate) mappedItem.postingdate = this.formatMonthYear(mappedItem.postingdate);
                if (mappedItem.postingDate) mappedItem.postingDate = this.formatMonthYear(mappedItem.postingDate);
                return mappedItem;
            });
        }
    },
    data () {
        return {
            ROOT_URL: "employeekpis/v2",
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 10000
            },

            storeNo: null,
            filters:{
                employeeCode: null,
                employeeName: null,
                storeCode: null,
                month: moment().format("YYYY-MM"),
            },
            rowCount: 0,
            departments: [],
            
            //DATA TABLE
            items: [],
            isLoading: true,
        }
    },
    methods: {
        formatMonthYear(value) {
            if (!value) return '';
            return moment(value).format('MM/YYYY');
        },
        fetchDepartment() {
            return http.get("departments/fetch").then(res => {
                this.departments = res.data;
            })
        },
        fetchData () {
            this.isLoading = true;
            return http.get(this.ROOT_URL, {
                params: this.params
            })
            .then(res => {
                if (res.data.data) {
                    this.items = res.data.data;
                    this.rowCount = res.data.rowCount || res.data.data.length;
                } else if (res.data.results) {
                    this.items = res.data.results;
                    this.rowCount = res.data.rowCount;
                } else if (Array.isArray(res.data)) {
                    this.items = res.data;
                    this.rowCount = res.data.length;
                } else if (res.data.items) {
                    this.items = res.data.items;
                    this.rowCount = res.data.total;
                } else {
                    this.items = [];
                    this.rowCount = 0;
                }
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.isLoading = false;
            })
        },
    },
    created () {
        this.fetchData();
        this.fetchDepartment();
    }
}
</script>
<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    background-color: #fcfcfc;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #f1f5f9 !important;
    font-size: 13px !important;
    text-transform: uppercase;
    white-space: nowrap;
    border-bottom: 2px solid #e2e8f0 !important;
    color: #334155 !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
    background-color: #f0fdfa !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    border-bottom: 1px solid #f1f5f9 !important;
}
</style>
